'use strict';
import React, { Component } from 'react';
import { GenericModal } from 'com-gyf-webcore-userinterfacecomponents';

class BotonEliminar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            deleteProductos: props.deleteProductos
        };
        this.deleteProductos = this.deleteProductos.bind(this);
    }

    openPopup() {
        $("#confirm-delete-header").modal();
    }

    deleteProductos() {
        this.state.deleteProductos(this.props.Id);
    }

    render() {
        return (
            <div>
                <button id="btnEliminar" className="btn btn" disabled={this.props.data} type="submit"
                    title="Eliminar los seleccionados" onClick={this.openPopup}>
                    <span className="glyphicon glyphicon-trash"></span>
                </button>
                <GenericModal type={"OK_CANCEL"} className="modal fade-out" onClick={this.deleteProductos}
                    id={"confirm-delete-header"} body={"Desea eliminar los productos seleccionados?"} />
            </div>
        );
    }
}

export default BotonEliminar